module.exports = __webpack_public_path__ + "img/integratedMarketing_4.a2adec9b.png";